/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import BackAction from './BackAction/index'
import EditAutomation from 'DesignSystem/EditAutomation/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/Automation/Content",
  onChange
  
}) {
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let eventValueData = fromData.useDataValue({ viewPath,
context: 'event',
})
let eventChangeData = fromData.useDataChange({ viewPath,
context: 'event',
})
let onUpdate = fromHelpers.useOnUpdate({
  children,
  viewPath,
  onChange
  
})
let onCancel = fromHelpers.useOnCancel({
  children,
  viewPath,
  onChange
  
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--pl-1-Z1Yf8zk': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pr-2-Z1Yf8zk': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pt-3-Z1Yf8zk': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--pb-4-Z1Yf8zk': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<BackAction
  viewPath={`${viewPath}/BackAction`}
/>
<EditAutomation
  viewPath={`${viewPath}/EditAutomation`}
 data="event"
 automation={eventValueData}
 onChange={eventChangeData}
 onUpdate={onUpdate}
 onCancel={onCancel}
/>
</div>
{children}
</React.Fragment>)
}